import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { backgrounds, colors, fonts } from '../theme';
import { plural } from '../text';
import { withTableNumbers } from '../seating';
import { Roster } from './Roster';
import { EventsStage, FinalStage, IntroStage, NightStage, SetupStage, ShootoutStage, VoteStage } from './stages';
const headText = (match) => {
    const players = `${match.totalCount} ${plural(match.totalCount, ['игрок', 'игрока', 'игроков'])}`;
    const inGame = `в игре ${match.aliveCount} из ${match.totalCount}`;
    switch (match.stage) {
        case 'final':
            return `Финал, ${players}`;
        case 'setup':
            return `Ночь знакомства, ${players}`;
        case 'night':
            return `Ночь ${match.dayNumber}, ${inGame}`;
        case 'night_result':
            // The night still belongs to the previous day number: this is the morning of the next one.
            return `День ${match.dayNumber + 1}, ${inGame}`;
        default:
            return `День ${match.dayNumber}, ${inGame}`;
    }
};
function StageContent({ match, nowSec }) {
    switch (match.stage) {
        case 'setup':
            return _jsx(SetupStage, { match: match });
        case 'intro':
            return _jsx(IntroStage, { match: match, nowSec: nowSec });
        case 'vote':
            return _jsx(VoteStage, { match: match, nowSec: nowSec });
        case 'shootout':
            return _jsx(ShootoutStage, { match: match });
        case 'day_result':
        case 'night_result':
            return _jsx(EventsStage, { match: match });
        case 'night':
            return _jsx(NightStage, {});
        case 'final':
            return _jsx(FinalStage, { match: match });
        default:
            return null;
    }
}
export function MatchView({ match: source, nowSec }) {
    const match = useMemo(() => withTableNumbers(source), [source]);
    const dark = match.stage === 'night' || match.stage === 'setup';
    return (_jsxs("div", Object.assign({ style: {
            position: 'absolute',
            inset: 0,
            background: dark ? backgrounds.night : backgrounds.day,
            boxSizing: 'border-box',
            padding: '52px 72px 56px',
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr) 700px',
            columnGap: 88,
            transition: 'background 600ms',
        } }, { children: [_jsxs("div", Object.assign({ style: { display: 'flex', flexDirection: 'column', minWidth: 0, minHeight: 0 } }, { children: [_jsxs("div", Object.assign({ style: { display: 'flex', alignItems: 'baseline', gap: 36 } }, { children: [_jsx("div", Object.assign({ style: { fontFamily: fonts.logo, fontSize: 56, lineHeight: 1, whiteSpace: 'nowrap' } }, { children: "Dark side Mafia" })), _jsx("div", Object.assign({ style: {
                                    fontSize: 26,
                                    letterSpacing: '0.2em',
                                    textTransform: 'uppercase',
                                    color: colors.muted,
                                    whiteSpace: 'nowrap',
                                } }, { children: headText(match) }))] })), _jsx("div", Object.assign({ style: {
                            flexGrow: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            gap: 24,
                            minHeight: 0,
                        } }, { children: _jsx(StageContent, { match: match, nowSec: nowSec }) }))] })), _jsx(Roster, { match: match })] })));
}
